import React from 'react';
import './Styles.css';
import { IconButton, IconButtonType, IconButtonVariant, IconButtonSize } from '@ids/react-icon-button';
import { Ui16Cross } from '@ids/react-icons';

const Notifications = ({ notifications, setNotifications }) => {
  const removeNotification = index => {
    setNotifications(prev => prev.filter((_, i) => i !== index));
  };

  if (!notifications.length) return null;
  return (
    <>
      <div className="agentConversionPage-notifications-container">
        {notifications.map((n, index) => (
          <div key={index} className={`agentConversionPage-notifications-row ${n.type}`}>
            <span>{n.message}</span>
            <IconButton
              type={IconButtonType.PLAIN}
              variant={IconButtonVariant.QUIET}
              size={IconButtonSize.X_SMALL}
              onClick={() => removeNotification(index)}>
              <Ui16Cross />
            </IconButton>
          </div>
        ))}
      </div>
    </>
  );
};

export default Notifications;
